import { apiConnector } from '../apiConnector'
import { setToken } from '../slice/authSlice'
import { baseUrl } from './api'

const{LOGIN_API}=baseUrl

export function login(email, password, navigate) {

    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", LOGIN_API, {
                email,
                password,
            })

            console.log("LOGIN API RESPONSE............", response)

            if (!response.data.success) {
                throw new Error(response.data.message)
            }

            // toast.success("Login Successful")
            dispatch(setToken(response.data.token))

            localStorage.setItem("token", JSON.stringify(response.data.token))
            localStorage.setItem("user", JSON.stringify(response.data.user))
            navigate("/admin")
        } catch (error) {
            console.log("LOGIN API ERROR............", error)
        }
        // dispatch(setLoading(false))
    }
}